// assets
import {
  DashboardOutlined,
  UserOutlined,
  DatabaseOutlined,
  PieChartOutlined,
  SettingOutlined
} from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  UserOutlined,
  DatabaseOutlined,
  PieChartOutlined,
  SettingOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: '',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'survey-setup',
      title: 'Survey Setup',
      type: 'item',
      url: '/survey-setup',
      icon: icons.SettingOutlined,
      breadcrumbs: false
    },
    {
      id: 'farmer-tracker',
      title: 'Farmer Invite',
      type: 'item',
      url: '/farmer-invite',
      icon: icons.UserOutlined,
      breadcrumbs: false
    },
    {
      id: 'farmers-db',
      title: 'Farmers Database',
      type: 'item',
      url: '/farmers-db',
      icon: icons.DatabaseOutlined,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
